import { SkyText, SkyButton } from "@skypointcloud/skypoint-ui";
import { ErrorCircle48Regular } from "@fluentui/react-icons";

import { IErrorCardProps } from "./commonComponents.interface";

export const ErrorCard = ({
  errorDescription = "Sorry, something went wrong. Try again later",
  showRefreshButton = false,
  refreshButtonText = "Refresh",
  callBackFunctionOnRefresh = () => undefined,
}: IErrorCardProps) => {
  return (
    <div
      className="mt-[20vh] flex flex-col items-center gap-2"
      role="alert"
    >
      <ErrorCircle48Regular style={{ color: "#d13438", width: "48px", height: "48px" }} />
      <SkyText className="font-semibold text-lg">Ooops!</SkyText>
      <SkyText className="text-sm max-w-[390px] text-center">{errorDescription}</SkyText>
      {showRefreshButton ? (
        <SkyButton
          appearance="primary"
          className="mt-4 px-4 py-2 border-0 text-white"
          onClick={callBackFunctionOnRefresh}
        >
          {refreshButtonText}
        </SkyButton>
      ) : null}
    </div>
  );
};
